import React, { useEffect, useMemo, useRef } from 'react';
import Style from './InputNumberAntd.module.scss';
import classNames from 'classnames';
import { Input, InputProps } from 'antd';

type TInputNumberAntdProps = InputProps;

const InputNumberAntd: React.FC<TInputNumberAntdProps> = (props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const className = useMemo(() => {
    if (props.className) {
      return classNames(Style['input-number'], props.className);
    }

    return Style['input-number'];
  }, [props.className]);

  const onKeyDown = (event) => {
    return ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault();
  };

  const onChange = (event) => {
    const value = event.target.value;
    const numericValue = value.replace(/\D/g, '');
    event.target.value = numericValue;

    if (props.onChange) {
      props.onChange(event);
    }
  };

  const onPaste = (event) => {
    event.preventDefault();
    const value = event.target.value;
    const pastedValue = event.clipboardData.getData('text/plain');
    const selectionStart = inputRef.current?.selectionStart;
    const selectionEnd = inputRef.current?.selectionEnd;
    const numericValue = pastedValue.replace(/[^\d]/g, '');
    const updatedValue =
      value.slice(0, selectionStart) + numericValue + value.slice(selectionEnd);
    event.target.value = updatedValue;

    if (props.onChange) {
      props.onChange(event);
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      const value = props.value as string;
      inputRef.current.value = value;
    }
  }, [props.value]);

  return (
    <Input
      ref={inputRef as any}
      {...props}
      type="text"
      onKeyDown={onKeyDown}
      onChange={onChange}
      onPaste={onPaste}
      className={className}
    />
  );
};

export default InputNumberAntd;
